import EmblaCarousel from 'embla-carousel';
import { setupPrevNextBtns, disablePrevNextBtns } from '../utils/PrevNextButtons.js';
import { resizeScroll } from '../core/ScrollService.js';

const parsePxAttr = (el, name) => {
    const value = parseInt(el.getAttribute(name) || '', 10);
    return Number.isFinite(value) && value > 0 ? value : 0;
};

const fitsStaticGrid = (viewport, count, card, gap) => {
    if (count < 1) {
        return false;
    }
    if (count === 1) {
        return true;
    }
    return (count * card) + ((count - 1) * gap) <= viewport + 2;
};

const mountEmbla = (domElt, domEmbla, section) => {
    const loop = domEmbla.getAttribute('data-loop') === 'true';
    const dragFree = domEmbla.getAttribute('data-dragfree') === 'true';
    const embla = EmblaCarousel(domEmbla, {
        align: 'start',
        loop,
        dragFree,
        draggable: true,
        containScroll: 'trimSnaps',
    });

    const domEmblaPrev = section?.querySelector('.carousel_nav_prev') || domElt.querySelector('.carousel_nav_prev');
    const domEmblaNext = section?.querySelector('.carousel_nav_next') || domElt.querySelector('.carousel_nav_next');
    if (domEmblaPrev && domEmblaNext) {
        setupPrevNextBtns(domEmblaPrev, domEmblaNext, embla);
        const disableBtns = disablePrevNextBtns(domEmblaPrev, domEmblaNext, embla);
        embla.on('select', disableBtns);
        embla.on('init', disableBtns);
    }

    embla.on('init', () => {
        resizeScroll();
    });

    return embla;
};

const initPartnersCarousels = (scope = document) => {
    const carousels = scope.querySelectorAll('[data-partners-carousel]');
    if (!carousels.length) {
        return;
    }

    carousels.forEach((domElt) => {
        if (typeof domElt._partnersCarouselTeardown === 'function') {
            domElt._partnersCarouselTeardown();
            domElt._partnersCarouselTeardown = null;
        }

        const domEmbla = domElt.querySelector('.embla');
        if (!domEmbla) {
            return;
        }

        const section = domElt.closest('section') || domElt.parentElement;
        const staticCard = parsePxAttr(domElt, 'data-static-card');
        const staticGap = parsePxAttr(domElt, 'data-static-gap');
        let embla = null;

        const teardownEmbla = () => {
            if (!embla) {
                return;
            }
            embla.destroy();
            embla = null;
        };

        const syncMode = () => {
            if (!document.contains(domElt)) {
                if (typeof domElt._partnersCarouselTeardown === 'function') {
                    domElt._partnersCarouselTeardown();
                }
                return;
            }

            const count = domEmbla.querySelectorAll('.embla__slide').length;
            const viewport = domEmbla.clientWidth;
            const isStatic = staticCard > 0 && fitsStaticGrid(viewport, count, staticCard, staticGap);

            if (section) {
                section.classList.toggle('is-static', isStatic);
            }

            if (isStatic) {
                teardownEmbla();
                return;
            }

            if (!embla) {
                embla = mountEmbla(domElt, domEmbla, section);
            } else {
                embla.reInit();
            }
        };

        syncMode();

        const resizeObserver = typeof ResizeObserver === 'function'
            ? new ResizeObserver(() => {
                syncMode();
            })
            : null;
        if (resizeObserver) {
            resizeObserver.observe(domEmbla);
        } else {
            window.addEventListener('resize', syncMode);
        }

        domElt._partnersCarouselTeardown = () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            } else {
                window.removeEventListener('resize', syncMode);
            }
            teardownEmbla();
            if (section) {
                section.classList.remove('is-static');
            }
        };
    });
};

export { initPartnersCarousels };
